import { createDCHook, collapseDataFromCall } from '../client';
import { getUsagesV4 } from '../services/UsageV4Service';

export const useUsageV4GetUsagesV4 = createDCHook('getUsagesV4', collapseDataFromCall(getUsagesV4), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});
